import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	feedbackFooter: {
		id: 'search_dialog_feedback_footer',
		defaultMessage: 'Help us improve search',
		description: 'Text in the search dialog to prompt users to provide feedback',
	},
});
